<template>
	<section class="content">

		<!-- Doctor Search -->
		<section class="doctor-search search-bg">
			<div class="row">

				<form class="search doctor-search__form large-collapse clear_fix">

					<div class="columns small-12 medium-12 large-4 large-offset-1 search__col-margin">
						<p class="search__label-select">Введите специальность или имя врача</p>

						<!-- Select -->
						<div class="search__inner select-outer">
							<select2
								:options="$parent.specializations"
								placeholder="Выберите специализацию"
								v-model="workerSearchModel.specialization_ids"></select2>
						</div>
						<!-- Select End -->

						<!-- Checkboxes -->
						<div class="search__inner">
							<div class="checkbox clear_fix">

								<div class="checkbox__inner">
									<label class="checkbox__label">
										<input class="checkbox__input" type="checkbox" value="adult" v-model="workerSearchModel.type">
										<span class="checkbox__custom-input"></span>
										<span class="checkbox__text checkbox__text_white">Взрослый</span>
									</label>
								</div>

								<div class="checkbox__inner">
									<label class="checkbox__label">
										<input class="checkbox__input" type="checkbox" value="childish" v-model="workerSearchModel.type">
										<span class="checkbox__custom-input"></span>
										<span class="checkbox__text checkbox__text_white">Детский</span>
									</label>
								</div>

							</div>
						</div>
						<!-- Checkboxes End -->
					</div>

					<div class="columns small-12 medium-12 large-4 search__col-margin">
						<p class="search__label-select">Выберите район или метро</p>

						<!-- Select -->
						<div class="search__inner select-outer">
							<select2 class="select"
											 :options="cities"
											 placeholder="Выберите район"
											 v-model="workerSearchModel.region" disabled></select2>
						</div>
						<!-- Select End -->

						<!-- Checkboxes -->
						<div class="search__inner">
							<div class="checkbox clear_fix">

								<div class="checkbox__inner">
									<label class="checkbox__label">
										<input class="checkbox__input" type="checkbox" value="private"
													 v-model="workerSearchModel.clinic_own_type">
										<span class="checkbox__custom-input"></span>
										<span class="checkbox__text checkbox__text_white">Частные<br> клиники</span>
									</label>
								</div>

								<div class="checkbox__inner">
									<label class="checkbox__label">
										<input class="checkbox__input" type="checkbox" value="state"
													 v-model="workerSearchModel.clinic_own_type">
										<span class="checkbox__custom-input"></span>
										<span class="checkbox__text checkbox__text_white">Гос.<br> клиники</span>
									</label>
								</div>

							</div>

							<!-- Checkboxes End -->
						</div>
					</div>

					<div class="columns small-12 medium-12 large-2 end">

						<div class="search__inner search__inner_pad">
							<a @click="searchDoctors" class="search__btn search__btn_show search__btn_size">Показать</a>
						</div>

						<div class="search__inner">
							<!--<p class="search__info">Найдено {{result.total}}</p>-->
						</div>

					</div>
				</form>
			</div>

		</section>
		<!-- Doctor Search End -->

		<!-- Doctors -->
		<section class="doctors section_pad">
			<div class="row">

				<div class="columns small-12 medium-12 large-12">
					<h2 class="section-title">Список врачей по запросу</h2>
				</div>

				<div class="columns small-12 medium-12 large-8">
					<!-- Docs Main Wrap -->
					<div class="doctors__main-wrap">

						<doctor-thumbnail v-for="doctor in doctors" :key="doctor._id" :doctor="doctor"></doctor-thumbnail>

					</div>
					<!-- Docs Main Wrap End -->

					<!-- Button -->
					<div class="basic-box__btns text_center" v-show="paginationOptions.current < paginationOptions.total">
						<button class="basic-box__btn btn_light-blue" @click="loadPage">
							Показать больше
							<i class="basic-box__icon_light basic-box__icon_arrow_down icon ion-chevron-down"></i>
						</button>
					</div>
					<!-- Button End -->

				</div>
				<!-- Column End -->

				<div class="columns small-12 medium-12 large-4">
					<div id="map" class="mapmain"><div class="temporary">Функционал карты временно недоступен</div></div>
				</div>
			</div>
		</section>
		<!-- Doctors End -->

		<appointment></appointment>
	</section>
</template>

<script>
	import DoctorThumbnail from '../../components/Thumbnails/DoctorThumbnail.vue';
	import Pagination from '../../components/Pagination.vue';
	import Appointment from '../../components/Modals/Appointment.vue';

	export default {
		name: "Doctors",
		components: {DoctorThumbnail, Pagination, Appointment},
		computed: {
			pagination() {
				return {
					total: this.totalCount,
					current: this.workerSearchModel.current_page
				}
			}
		},
		mounted() {
			this.searchDoctors()
		},
		data() {
			return {
				stars: 3,
				doctors: [],
				cities: [
					{id: "Kiev", text: 'Киев'},
					{id: "Kharkov", text: 'Харьков'},
					{id: "Odessa", text: 'Одесса'},
					{id: "Lvov", text: 'Львов'}
				],
				paginationOptions: {
					total: null,
					current: 1
				},
				workerSearchModel: {
					per_page: 15,
					current_page: 1,
					type: this.$route.query.type || [],
					clinic_own_type: this.$route.query.clinic_own_type || [],
					region: this.$route.query.region || '',
					specialization_ids: this.$route.query.specialization_ids || ''
				}
			}
		},
		methods: {
			searchDoctors() {
				this.$store.dispatch('worker/search', this.workerSearchModel).then(result => {
					this.doctors = result.users;
					this.paginationOptions.total = result.pages;
				})
			},
			loadPage() {
				this.workerSearchModel.per_page += 15;
				this.paginationOptions.current += 1;
				this.searchDoctors();
			}
		}
	}
</script>

<style scoped>
	.link_black {
		color: #333;
	}

	.fix {
		text-align: center;
		line-height: 56px;
		font-size: 1.5em;
	}

	.user_fix {
		line-height: 136px;
		text-align: center;
		color: white;
		font-size: 3em;
	}
</style>



// WEBPACK FOOTER //
// Doctors.vue?029a7d82